export default __webpack_public_path__ + "static/media/dark.3162eb29.svg";